// Alocação de Pessoal (Gestão Orçamentária): grade mensal de % de alocação dos colaboradores
// da OPERAÇÃO em projetos. Espelha backend/config.py ROLES_ALOCACAO_PESSOAL — mantenha os dois
// em sincronia.
export const ROLES_ALOCACAO_PESSOAL = ["admin", "EXECUTIVA", "GESTOR_ESTRATEGICO", "OPERACAO", "ASSISTENTEOPERACAO"];
